export const singularStatusMapLabel = {
  a_confirmar: 'A confirmar',
  questionada: 'Questionada',
  andamento: 'Em andamento',
  encerrada: 'Encerrada',
  aguardando_distribuir: 'Aguardando distribuir',
  a_notificar: 'A notificar',
  abertura: 'Abertura',
  reaberto: 'Reaberto',
  cancelada: 'Cancelada',
  reabrindo: 'Reabrindo',
  em_distribuicao: 'Em distribuição',
  local_fechado: 'Local fechado',
}

export const statusColorMap = {
  a_confirmar: 'text-primary',
  questionada: 'text-primary',
  andamento: 'text-primary',
  encerrada: 'text-success',
  aguardando_distribuir: 'Aguardando distribuir',
  a_notificar: 'A notificar',
  abertura: 'Abertura',
  reaberto: 'Reaberto',
  cancelada: 'Cancelada',
  reabrindo: 'Reabrindo',
  em_distribuicao: 'Em distribuição',
  local_fechado: 'Local fechado',
}
